import React, {useState} from 'react';
import Upload from './Upload';
import Modal from '../../component/Inc/Modal';
//image
import ImgProfile from 'contents/assets/img/@profile.png';
import 'contents/assets/scss/common/_chat.scss';

function Chat() {
  const [openInvite, setOpenInvite] = useState(false);
  const [openRename, setOpenRename] = useState(false);
  const [openLeave, setOpenLeave] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const listItems = ['Zero2022', 'Zero2022', 'Zero2022', 'Zero2022', 'Zero2022', 'Zero2022', 'Zero2022', 'Zero2022', 'Zero2022'];
  return (
    <section className="chat_sec">
      <article className="profile_box">
        <p className="profile_img">
          <img src={ImgProfile} alt="프로필이미지" />
        </p>
        <div className="info">
          <p className="name">홍길동멘토 (27/여)</p>
        </div>
        <button className="btn_menu"></button>
        <div className="chat_menu_wrap">
          <div className="chat_menu">
            <button
              onClick={() => {
                setOpenInvite(true);
              }}
              className="item"
            >
              대화상대 초대하기
            </button>
            <button
              onClick={() => {
                setOpenRename(true);
              }}
              className="item"
            >
              채팅방 이름 변경
            </button>
            <button onClick={() => setOpenLeave(true)} className="item">
              채팅방 나가기
            </button>
          </div>
        </div>
      </article>
      {/*채팅내용 스크롤*/}
      <div className="scroll_body scroll">
        {/* <p className='date_area'><span>2023.5.30</span></p> */}
        <article className="get">
          <p className="img">
            <img src={ImgProfile} alt="프로필이미지" />
          </p>
          <div className="wrap">
            <p className="name_field">
              홍길동 <span className="date">2023, 05, 11 18:30</span>
            </p>
            <div className="message_box">안녕하세요안녕하세요안녕하세요안녕하세요안녕하세요안녕하세요안녕하세요</div>
          </div>
        </article>
        <article className="send">
          <div className="wrap">
            <p className="date">18:30</p>
            <div className="message_box">
              안녕하세요.
              <br />
              만나서 반갑습니다.안녕하세요.
              <br />
              만나서 반갑습니다.안녕하세요.
              <br />
              만나서 반갑습니다.안녕하세요.
              <br />
              만나서 반갑습니다.안녕하세요.
              <br />
              만나서 반갑습니다.
            </div>
          </div>
        </article>
        <article className="get next">
          <p className="img">
            <img src={ImgProfile} alt="프로필이미지" />
          </p>
          <div className="wrap">
            <p className="name_field">
              홍길동 <span className="date">2023, 05, 12 18:30</span>
            </p>
            <div className="message_box">안녕하세요</div>
          </div>
        </article>
        <article className="send">
          <div className="wrap">
            <p className="date">18:30</p>
            <div className="message_box">
              안녕하세요.
              <br />
              만나서 반갑습니다.
            </div>
          </div>
        </article>
        <article className="get">
          <p className="img">
            <img src={ImgProfile} alt="프로필이미지" />
          </p>
          <div className="wrap">
            <p className="name_field">
              홍길동 <span className="date">2023, 05, 12 18:30</span>
            </p>
            <div className="message_box">안녕하세요안녕하세요안녕하세요안녕하세요안녕하세요안녕하세요안녕하세요</div>
          </div>
        </article>
        <article className="send next">
          <div className="wrap">
            <p className="date">18:30</p>
            <div className="message_box">
              안녕하세요.
              <br />
              만나서 반갑습니다.안녕하세요.
              <br />
              만나서 반갑습니다.안녕하세요.
              <br />
              만나서 반갑습니다.안녕하세요.
              <br />
              만나서 반갑습니다.안녕하세요.
              <br />
              만나서 반갑습니다.
            </div>
          </div>
        </article>
        <article className="get next">
          <p className="img">
            <img src={ImgProfile} alt="프로필이미지" />
          </p>
          <div className="wrap">
            <p className="name_field">
              홍길동 <span className="date">2023-06-01(수)</span>
            </p>
            <div className="message_box">안녕하세요</div>
          </div>
        </article>
        <article className="send">
          <div className="wrap">
            <p className="date">18:35</p>
            <div className="message_box">
              안녕하세요.
              <br />
              만나서 반갑습니다.
            </div>
          </div>
        </article>
      </div>
      {/*메시지 입력*/}
      <article className="chat_bottom">
        <textarea name="input_msg" id="input_msg" placeholder="내용 입력" className="textarea"></textarea>
        <div className="com_btn_wrap com_input_upload">
          <Upload title="파일찾기" className="com_btn line gray xs btn_file" />
          <button id="submit" className="com_btn orange xs">
            전송
          </button>
        </div>
      </article>
      <Modal open={openInvite} close={() => setOpenInvite(false)} type="type_alert">
        <p className="pop_tit">채팅인원</p>
        <div className="content_container">
          <div className="com_scroll_list_wrap">
            <ul className="com_scroll_list pick">
              {listItems.map((item, index) => (
                <li key={index} className={`item ${selectedItem === index ? 'selected' : ''}`} onClick={() => setSelectedItem(index)}>
                  {item}
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className="btn_container">
          <button className="com_btn orange xs">대화상대 초대하기</button>
        </div>
      </Modal>
      <Modal open={openRename} close={() => setOpenRename(false)} type="type_alert">
        <p className="pop_tit">채팅방 이름 변경</p>
        <div className="content_container">
          <div className="pop_board_tit">변경할 이름 입력</div>
          <input type="text" className="input" />
        </div>
        <div className="btn_container">
          <button className="com_btn lightGray xs">취소</button>
          <button className="com_btn orange xs">확인</button>
        </div>
      </Modal>
      <Modal open={openRename} close={() => setOpenRename(false)} type="type_alert">
        <p className="pop_tit">채팅방 이름 변경</p>
        <div className="content_container">
          <div className="pop_board_tit">변경할 이름 입력</div>
          <input type="text" className="input" />
        </div>
        <div className="btn_container">
          <button className="com_btn lightGray xs">취소</button>
          <button className="com_btn orange xs">확인</button>
        </div>
      </Modal>
      <Modal open={openLeave} close={() => setOpenLeave(false)} type="type_alert">
        <p className="pop_tit">알 림</p>
        <div className="content_container">
          <p className="txt">
            메시지가 삭제됩니다.
            <br />
            나가시겠습니까?
          </p>
        </div>
        <div className="btn_container">
          <button className="com_btn gray xs">취소</button>
          <button className="com_btn orange xs">나가기</button>
        </div>
      </Modal>
    </section>
  );
}

export default Chat;
